import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import _ from 'lodash';
import React, { Component, lazy } from 'react';
import { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { connect } from 'react-redux';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import styled from 'styled-components';
import '../../assets/css/custom-login.scss';
import '../../assets/css/login.scss';
import loginImg from '../../assets/static/signup_img.svg';
import CONSTANTS from '../../constants';
import ViewHelper from '../../helpers/ViewHelper';
import AnalyticsService from '../../services/AnalyticsService';
import LoginService from '../../services/LoginService';
import UserLocationService from '../../services/UserLocationService';
import InlineLoader from '../shared/InlineLoader';
import withBackButtonHandled from '../shared/WithBackButtonHandled';
const ReactCodeInput = lazy(() => import('react-verification-code-input'));
const PhoneInput = lazy(() => import('react-phone-number-input'));
const recaptchaRef = React.createRef()

class CustomLogin extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isValid: false,
      openModal: false,
      showCodeInput: false,
      timerSecond: 0,
      loading: false,
      fbDetails: {},
      tokenData: {},
      newUser: false,
      phone_number: '',
      first_name: '',
      last_name: '',
      email: '',
      errors: [],
      enableSubmit: false,
      imagesLoaded: 0,
      code_check_loading: false,
      is_whatsapp_verification: false,
      whatsapp_code_loading: false,
      whatsapp_otp_code: '',
      whatsapp_btn_enable: false,
      whatsapp_enable: false,
      otpSettings: {},
      selecetedCountry: '',
      settings: {},
      recaptchaToken: ''
    };
    this.recaptchaVerifier = null;
    this.startTimerInterval = React.createRef();
    this.timeoutId = null;

  }

  async componentDidMount() {
    let settings = await LoginService.getOTPSettings();
    await this.setState({ otpSettings: settings });
  }

  async getWhatsAppStatus() {
    let phone_no = this.state.phone_number;
    let loc_id = this.props._location.loc_id;
    let code = this.state.whatsapp_otp_code;
    let status = await LoginService.getWhatsAppOTPDetails({ phoneNumber: phone_no, loc_id: loc_id, code })
    if (status === 1) {
      clearInterval(this.timeoutId);
      this.firebaseEvent(CONSTANTS.EVENTS.GENERAL.OTP_VERIFIED);
      await this.setState({ showCodeInput: false, loadingCode: false, isValid: true, phone_number: '' });
      await this.responseFirebase({ phoneNumber: phone_no });
    }
  }

  componentWillUnmount() {
    clearInterval(this.timeoutId);
  }

  firebaseEvent(eventName) {
    AnalyticsService.logEvent(eventName, {
      event: eventName
    });
  }

  toggleModal() {
    this.firebaseEvent(CONSTANTS.EVENTS.GENERAL.LOGIN);
    this.setState({ openModal: !this.state.openModal, showCodeInput: false, phone_number: '' });
  }

  async trackEvent(eventName, eventData) {
    try {
      if (window.clarity && typeof window.clarity.apply === 'function') {
        window.clarity('set', eventName, eventData.page);
      } else {
        console.warn('Clarity object is not defined or has no apply method.');
      }
    } catch (error) {
      console.error('Error integrating Clarity:', error);
    }
  }

  async loginWithPhone() {
    await this.trackEvent('Request Otp', { page: 'Main Page' });

    // Check network connection
    const connection = window.navigator.onLine;
    if (!connection) {
      ViewHelper.showNetworkAlert(this.props._location.name);
      return;
    }

    // Validate phone number
    if (this.state.phone_number === '') {
      ViewHelper.showAlert({
        title: 'Alert',
        text: 'Please enter your phone number.'
      });
      return;
    }

    // Update state for loading
    this.setState({ isValid: false, loadingCode: true, whatsapp_btn_enable: false, whatsapp_enable: false });

    let selecetedCountry = this.state.selecetedCountry;
    if (this.state.selecetedCountry.indexOf('+') === -1) {
      selecetedCountry = '+' + this.state.selecetedCountry;
    }

    let settings;
    try {
      // Find settings for the selected country
      settings = _.find(this.state.otpSettings, item => item.country_code === selecetedCountry);
      if (!settings) {
        throw new Error('No settings found for the selected country code.');
      }
      this.setState({ settings });
    } catch (error) {
      this.setState({ isValid: true, loadingCode: false });
      console.error('Error finding OTP settings:', error);
      ViewHelper.showAlert({
        title: 'Alert',
        text: 'Failed to load OTP settings. Please try again later.'
      });
      return;
    }
    try {
      // Handle different OTP gateway scenarios
      if (settings.sms_gateway_id === CONSTANTS.OTP_GETWAYS.UNIFONIC) {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(CONSTANTS.GOOGLE_RECAPTCHA_KEY_V3, { action: 'submit' }).then(async (token) => {
            await this.loginWithUnifonic(this.state.phone_number, token, settings);
          });
        });
      } else if (settings.sms_gateway_id === CONSTANTS.OTP_GETWAYS.FIREBASE) {
        await this.loginWithFirebase(settings, false);
      } else if (settings.sms_gateway_id === CONSTANTS.OTP_GETWAYS.JAZZ) {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(CONSTANTS.GOOGLE_RECAPTCHA_KEY_V3, { action: 'submit' }).then(async (token) => {
            await this.loginWithJazz(this.state.phone_number, token, settings);
          });
        });
      } else if (settings.sms_gateway_id === CONSTANTS.OTP_GETWAYS.NONE && settings.is_whatsapp === 1) {
        clearInterval(this.startTimerInterval.current);
        this.setState({ loadingCode: false, isValid: true, whatsapp_enable: true });
        this.enableWhatsAppVerification(!this.state.is_whatsapp_verification);
      } else {
        throw new Error('Unsupported SMS gateway or country code.');
      }
    } catch (error) {
      this.setState({ isValid: true, loadingCode: false });
      ViewHelper.showAlert({
        title: 'Alert',
        text: `An error occurred: ${error.message}.Please try again`
      });
    }
  }


  async confirmCode(code) {
    await this.trackEvent('Submit Otp', { page: 'Main Page' });
    try {
      if (this.state.settings.sms_gateway_id === CONSTANTS.OTP_GETWAYS.UNIFONIC) {
        await this.proceedUnifonicVerification(this.state.phone_number, code);
      } else if (this.state.settings.sms_gateway_id === CONSTANTS.OTP_GETWAYS.FIREBASE) {
        await this.proceedFirebaseVerification(code);
      } else if (this.state.settings.sms_gateway_id === CONSTANTS.OTP_GETWAYS.JAZZ) {
        await this.proceedJazzVerification(this.state.phone_number, code);
      } else {
        ViewHelper.showAlert({
          title: 'Alert',
          text: 'Sorry! This restaurant does not allow orders from this country code.'
        });
      }
    } catch (error) {
      this.setState({
        openModal: false,
        loadingCode: false,
        code: '',
        confirmationResult: null
      });
      ViewHelper.showAlert({
        title: 'Alert',
        text: `An error occurred: ${error.message}.Please try again`
      });
    }
  }

  async requestLoginAgain() {
    await this.setState({ code: '' });
    clearInterval(this.startTimerInterval.current);
    if (this.state.settings.sms_gateway_id === CONSTANTS.OTP_GETWAYS.UNIFONIC) {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(CONSTANTS.GOOGLE_RECAPTCHA_KEY_V3, { action: 'submit' }).then(async (token) => {
          await this.loginWithUnifonic(this.state.phone_number, token, this.state.settings);
        });
      });
    } else if (this.state.settings.sms_gateway_id === CONSTANTS.OTP_GETWAYS.FIREBASE) {
      this.loginWithFirebase(this.state.settings, true);
    } else if (this.state.settings.sms_gateway_id === CONSTANTS.OTP_GETWAYS.JAZZ) {
      window.grecaptcha.ready(() => {
        window.grecaptcha.execute(CONSTANTS.GOOGLE_RECAPTCHA_KEY_V3, { action: 'submit' }).then(async (token) => {
          await this.loginWithJazz(this.state.phone_number, token, this.state.settings);
        });
      });
    } else {
      ViewHelper.showAlert({
        title: 'Alert',
        text: 'Sorry! This restaurant does not allow orders from this country code.'
      });
    }
  }

  async loginWithJazz(phone, token, settings) {
    let location = this.props._location;
    let response = await LoginService.createJazzVerification({
      phone: phone,
      captcha_token: token,
      loc_id: location ? location.loc_id : 0,
      name: location ? location.name : ''
    });
    if (response.status >= 200 && response.status < 300) {
      this.firebaseEvent(CONSTANTS.EVENTS.GENERAL.OTP_REQUESTED);
      this.setState({
        openModal: true,
        showCodeInput: true,
        loadingCode: false,
        settings: settings
      });
      this.startTimer();
    } else {
      await this.setState({ isValid: true, loadingCode: false, whatsapp_btn_enable: true });
      ViewHelper.showAlert({
        title: 'Alert',
        text: response.message
      });
    }
  }

  async loginWithUnifonic(phone, token, settings) {
    let response = await LoginService.createVerification({
      phone: phone,
      captcha_token: token
    });
    if (response.id) {
      this.firebaseEvent(CONSTANTS.EVENTS.GENERAL.OTP_REQUESTED);
      this.setState({
        openModal: true,
        showCodeInput: true,
        loadingCode: false,
        settings: settings
      });
      this.startTimer();
    }
  }

  loginWithFirebase(settings, isResend) {
    if (!isResend) {
      if (!firebase.apps.length) firebase.initializeApp(CONSTANTS.FIREBASE_CONFIG);
      if (!window.recaptchaVerifier) {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
          size: 'invisible'
        });
        window.recaptchaVerifier.render().then((widgetId) => {
          window.recaptchaWidgetId = widgetId;
        });
      }
    }
    firebase
      .auth()
      .signInWithPhoneNumber(this.state.phone_number, window.recaptchaVerifier)
      .then(async (confirmationResult) => {
        this.firebaseEvent(CONSTANTS.EVENTS.GENERAL.OTP_REQUESTED);
        this.setState({
          openModal: true,
          showCodeInput: true,
          confirmationResult,
          loadingCode: false,
          settings: settings
        });
        this.startTimer();
      })
      .catch((error) => {
        window.recaptchaVerifier.reset(window.recaptchaWidgetId);
        this.showError(error, false)
      });
  }

  async responseFirebase(fbDetails) {
    if (fbDetails && fbDetails.phoneNumber) {
      let location = this.props._location;
      fbDetails.loc_id = location && location.parent_id && location.is_outlet == 1 ? location.parent_id : location.loc_id;
      this.login(fbDetails, 'phoneLogin');
    }
  }
  async proceedFirebaseVerification(code) {
    await this.state.confirmationResult.confirm(code)
      .then(async (res) => {
        this.setState({ loadingCode: true });
        this.firebaseEvent(CONSTANTS.EVENTS.GENERAL.OTP_VERIFIED);
        await this.responseFirebase(res.user);
      })
      .catch(async (error) => {
        console.log(error);
        await this.setState({ openModal: false, code: '', loadingCode: false, confirmationResult: null });
      })
  }

  async proceedUnifonicVerification(phone, code) {
    let response = await LoginService.checkVerification({
      phone: phone,
      code: code
    });
    if (response.error_code === CONSTANTS.UNIFONIC_CODES.CORRECT) {
      this.setState({ loadingCode: true });
      this.firebaseEvent(CONSTANTS.EVENTS.GENERAL.OTP_VERIFIED);
      await this.responseFirebase({ phoneNumber: this.state.phone_number });
    } else if (response.error_code === CONSTANTS.UNIFONIC_CODES.INCORRECT) {
      await this.setState({ openModal: false, code: '', loadingCode: false });
      ViewHelper.showAlert({
        title: 'Incorrect',
        text: 'Your code is incorrect.'
      });
    } else if (response.error_code === CONSTANTS.UNIFONIC_CODES.ATTEMPTSEXCEED) {
      await this.setState({ openModal: false, code: '', loadingCode: false });
      ViewHelper.showAlert({
        title: 'Attemp Exceeds',
        text: 'Your number of attempts has bee exceeded. Please try again later.'
      });
    } else if (response.error_code === CONSTANTS.UNIFONIC_CODES.CODEEXPIRED) {
      await this.setState({ openModal: false, code: '', loadingCode: false });
      ViewHelper.showAlert({
        title: 'Code Expired',
        text: 'Your code has been expired. Please try again .'
      });
    } else {
      ViewHelper.showAlert({
        title: 'Alert',
        text: 'Something went wrong.'
      });
    }
  }

  async proceedJazzVerification(phone, code) {
    let response = await LoginService.checkJazzVerification({
      phone: phone,
      code: code
    });
    if (response.status >= 200 && response.status < 300) {
      this.setState({ loadingCode: true });
      this.firebaseEvent(CONSTANTS.EVENTS.GENERAL.OTP_VERIFIED);
      await this.responseFirebase({ phoneNumber: this.state.phone_number });
      setTimeout(() => {
        this.setState({ showCodeInput: false, loadingCode: false, isValid: true });
      }, 2000);
    } else {
      ViewHelper.showAlert({
        title: 'Alert',
        text: response.message
      });
    }
  }

  startTimer() {
    this.setState({
      ...this.state,
      timerSecond: 20
    });
    this.startTimerInterval.current = setInterval(() => {
      if (this.state.timerSecond !== 0) {
        this.setState({
          ...this.state,
          timerSecond: this.state.timerSecond - 1
        });
      }
    }, 1000);
  }


  async showError(error, isResend) {
    if (!isResend) {
      this.setState({
        showCodeInput: false,
        openModal: false,
        isValid: true,
        loadingCode: false,
        whatsapp_btn_enable: true
      });
    }
    ViewHelper.showAlert({
      title: 'Error',
      text: error.message ? error.message : 'Some error occurred'
    });
  }

  async handleInputChange(event) {
    // let settings = await LoginService.getOTPSettings();
    // console.log(settings);
    this.setState({ [event.target.name]: event.target.value }, this.enableSubmit);
  }

  enableSubmit() {
    if (
      this.state.email &&
      this.state.first_name &&
      this.state.last_name &&
      this.state.phone_number &&
      isValidPhoneNumber(this.state.phone_number)
    )
      this.setState({ enableSubmit: true });
    else this.setState({ enableSubmit: false });
  }

  async login(fbDetails, loginType) {
    this.setState({ code_check_loading: true }, async () => {
      try {
        let tokenData = await LoginService[loginType](fbDetails);
        if (tokenData.type === CONSTANTS.LOGIN.VARIABLES.USER_TYPES.NEW || tokenData.profileEmpty) {
          await this.trackEvent('Successfully logged in', { page: 'Main Page' });
          const { email, phone_number, first_name, last_name } =
            LoginService.transformFbDetails(fbDetails);
          const defaultState = { email, phone_number, first_name, last_name };
          this.setState({
            newUser: true,
            fbDetails: fbDetails,
            tokenData: tokenData,
            ...defaultState,
            code_check_loading: false
          });
        } else {
          await this.trackEvent('Successfully logged in', { page: 'Main Page' });
          this.setTokenAndRedirect(tokenData);
        }
      } catch (e) {
        console.log(e);
        alert('Login Failed: Invalid username or password!');
        this.setState({ loading: false });
      }
    });
  }

  async setTokenAndRedirect(tokenData) {
    LoginService.setLoginData(tokenData);
    if (this.props.isLogin) {
      await UserLocationService.syncWithServer();
      if (this.props.onLoginSuccess) {
        return this.props.onLoginSuccess();
      }
      alert('Login successfully done');
      this.props.toggleModal();
      // this.props.history.replace(`${CONSTANTS.BASE_URL}${ParamHelper.getLocationId(this.props)}/confirm`);
    } else {
      if (this.props.onLoginFailed) {
        return this.props.onLoginFailed();
      }
      alert('Login failed');
      // this.props.history.replace(this.returnURL(), this.returnData());
    }
  }

  async saveProfile() {
    this.setState({ signUpLoader: true });

    const { email, phone_number, first_name, last_name } = this.state;
    try {
      await LoginService.updateProfile(
        { email, phone_number, first_name, last_name },
        this.state.tokenData
      );
      await this.trackEvent('Complete registration', { page: 'Main Page' });
      this.setTokenAndRedirect(this.state.tokenData);
    } catch (e) {
      console.log('error', e);
      this.setState({ signUpLoader: false });
      alert('Could not signup');
    }
  }

  renderUserInfoForm() {
    return [
      <div className="top-section pt-3 mt-3" key="top-section">
        <div className="sign-up-fields pt-3">
          <div className="form-group">
            <input
              className={`form-control ${this.state.email ? 'is-valid' : ''}`}
              type="email"
              name="email"
              placeholder="Email"
              value={this.state.email}
              onChange={this.handleInputChange.bind(this)}
            />
          </div>

          <div className="form-group">
            <input
              className={`form-control ${this.state.first_name ? 'is-valid' : ''}`}
              type="text"
              name="first_name"
              placeholder="First name"
              value={this.state.first_name}
              onChange={this.handleInputChange.bind(this)}
            />
          </div>

          <div className="form-group">
            <input
              className={`form-control ${this.state.last_name ? 'is-valid' : ''}`}
              type="text"
              name="last_name"
              placeholder="Last name"
              value={this.state.last_name}
              onChange={this.handleInputChange.bind(this)}
            />
          </div>

          <PhoneInput
            className={'phone-input'}
            inputProps={{
              className: `form-control ${this.state.phone_number && isValidPhoneNumber(this.state.phone_number)
                ? 'is-valid'
                : ''
                }`
            }}
            key={'phone_number'}
            defaultCountry={'PK'}
            disabled={
              this.state.fbDetails.phoneNumber && this.state.fbDetails.phoneNumber.length > 0
            }
            value={this.state.phone_number}
            placeholder={'Enter phone number'}
            onChange={(phone_number) =>
              this.handleInputChange({ target: { name: 'phone_number', value: phone_number } })
            }
          />

          <Button
            className="f2 text-white mt-3 mb-3 btn btn-dark w-100"
            disabled={!this.state.enableSubmit}
            onClick={this.saveProfile.bind(this)}
          >
            {this.state.signUpLoader && <InlineLoader />}
            {!this.state.signUpLoader && 'Save Information!'}
          </Button>
        </div>
      </div>
      // <img className='bottom-image' src={loginBottom} alt='slider' key='bottom-image'/>
    ];
  }
  async enableWhatsAppVerification(wverifi) {
    await this.setState({
      is_whatsapp_verification: wverifi, whatsapp_code_loading: true, openModal: true,
      showCodeInput: true,
      loadingCode: false,
    }, async () => {
      let phone_no = this.state.phone_number;
      let loc_id = this.props._location.loc_id;
      this.firebaseEvent(CONSTANTS.EVENTS.GENERAL.REVERSE_OTP_REQUESTED);
      let otp_code = await LoginService.createWhatsAppOTP({ phoneNumber: phone_no, loc_id: loc_id })
      await this.setState({ whatsapp_code_loading: false, whatsapp_otp_code: otp_code })
      this.timeoutId = setInterval(this.getWhatsAppStatus.bind(this), 5000);
    });
  }

  renderModalBody() {
    const branding_btn = this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn';
    const openInNewTab = (url) => {
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null;
    };
    if (this.state.showCodeInput === true) {
      if (this.state.newUser) {
        if (this.state.code_check_loading) {
          return (
            <div className="text-sm spinner-border primary-font-color ml-2" role="status">
              <span className="sr-only"></span>
            </div>
          );
        } else {
          return this.renderUserInfoForm();
        }
      } else {
        return (
          <div className={'top-section'}>
            <div className="image-section">
              <img src={loginImg} alt="" />
              <div className="image-section-content">
                <h2 className='card-font-color'>Verify your phone number!</h2>
                {!this.state.is_whatsapp_verification ? <p className='card-font-color'>Provide the OTP sent to you.</p> : ''}
                {this.state.is_whatsapp_verification ? <p className='card-font-color'>SMS not working? Try reverse OTP.</p> : ''}
              </div>
            </div>
            {!this.state.is_whatsapp_verification && (
              <div className="popup-otp-input-section">
                <div className="d-flex justify-content-center">
                  <ReactCodeInput
                    fields={6}
                    type={'number'}
                    fieldWidth={48}
                    onChange={(code) => this.setState({ code })}
                    onComplete={(code) => this.confirmCode(code)}
                  />
                  {this.state.loadingCode && (
                    <div className="text-sm spinner-border primary-font-color ml-2 mt-2" role="status">
                      <span className="sr-only"></span>
                    </div>
                  )}
                  <div className="content-section d-flex">
                    <h4 className='card-font-color'>
                      Didn't get the code? <a href='#/' style={{ cursor: 'pointer' }}>&nbsp;</a>
                    </h4>
                    <h4 className='card-font-color'>
                      <a
                        className={`branding-btn-color fw-bold ${this.state.timerSecond === 0 ? 'text-decoration-underline' : ''}`}
                        href='#/'
                        style={{ cursor: 'pointer' }}
                        onClick={this.state.timerSecond === 0 && this.requestLoginAgain.bind(this)}
                      >
                        {this.state.timerSecond === 0 ? 'Resend SMS' : 'Request again'}{' '}
                        {this.state.timerSecond !== 0 && `in ${this.state.timerSecond}s `}
                      </a>
                    </h4>

                  </div>
                  <p style={{ cursor: 'pointer', fontSize: '14px', textAlign: 'center' }}>
                    <a
                      className='branding-btn-color fw-bold text-decoration-underline'
                      href='#/'
                      onClick={() => {
                        clearInterval(this.startTimerInterval.current);
                        this.setState({ ...this.state, showCodeInput: false, loadingCode: false, isValid: true });
                      }}
                    >
                      Change Number
                    </a>
                    {this.state.timerSecond === 0 && this.state.settings.is_whatsapp === 1 && (
                      <>
                        <br></br>
                        <a
                          className='branding-btn-color fw-bold text-decoration-underline'
                          href='#/'
                          onClick={() => {
                            clearInterval(this.startTimerInterval.current);
                            this.setState({ loadingCode: false, isValid: true });
                            this.enableWhatsAppVerification(!this.state.is_whatsapp_verification)
                          }}
                        >
                          Try Whatsapp Verification
                        </a>
                      </>
                    )}
                  </p>
                </div>
              </div>
            )}
            {this.state.is_whatsapp_verification && (

              this.state.whatsapp_code_loading ?

                <div className='d-flex justify-content-center'>
                  <div className="text-sm spinner-border primary-font-color ml-2" role="status">
                    <span className="sr-only"></span>
                  </div>
                </div>
                :
                <div className="popup-otp-input-section">
                  <div className="d-flex justify-content-center">

                    <div className="text-center">
                      <h4 className='primary-font-color fw-light'>
                        Your code :
                      </h4>
                      <h1 className='primary-font-color'><b> {this.state.whatsapp_otp_code} </b></h1>
                    </div>
                    <p style={{ cursor: 'pointer', fontSize: '14px', textAlign: 'center', margin: '0px' }}>
                      <a
                        className={`btn btn-primary ${branding_btn}`}
                        href='#/'
                        onClick={() => {
                          let url = `https://wa.me/923210011888/?text=` + this.state.whatsapp_otp_code;
                          openInNewTab(url);
                        }}
                      >
                        Whatsapp us this code
                      </a>
                      <br></br>
                      <p
                        className='branding-btn-color mt-1 fw-light'
                        href='#/'
                      >
                        <a>Once we receive the code,you will </a>
                        <br></br>
                        <a>automatically be logged in.</a>
                        <br></br>
                        <a
                          className={`branding-btn-color fw-bold text-decoration-underline`}
                          href='#/'
                          onClick={() => {
                            this.setState({ ...this.state, showCodeInput: false, loadingCode: false, isValid: true })
                            if (!this.state.whatsapp_btn_enable && !this.state.whatsapp_enable) {
                              this.enableWhatsAppVerification(!this.state.is_whatsapp_verification)
                            } else {
                              this.setState({ is_whatsapp_verification: !this.state.is_whatsapp_verification })
                            }
                          }}
                        >
                          Back
                        </a>
                      </p>

                    </p>
                  </div>
                </div>
            )}
          </div>
        );
      }
    } else {
      return (
        <div className={'top-section'}>
          <div className="image-section">
            <img src={loginImg} alt="" />
            <div className="image-section-content">
              <h2 className='card-font-color'>Hey! You're new here!</h2>
              <p className='card-font-color'>Use our quick-login to sign up and complete your order in one minute.</p>
            </div>
          </div>
          <div className="phone-input-section p-2">
            <PhoneInput
              placeholder={'Enter your phone number'}
              className={'phone-input'}
              defaultCountry={'PK'}
              value={this.state.phone_number}
              onChange={(phone_number) => {
                if (phone_number !== '' && phone_number !== undefined && phone_number !== null) {
                  const phoneNumber = parsePhoneNumber(phone_number.toString());
                  this.setState({ phone_number, isValid: isValidPhoneNumber(`${phone_number}`), selecetedCountry: phoneNumber ? '+' + phoneNumber.countryCallingCode : '92' })
                }
              }}
            />
            <div className={`actions get-code `} key={'button'}>
              {!this.state.loadingCode && (
                <button
                  id="sign-in-button"
                  disabled={!this.state.isValid}
                  className={`btn btn-primary login-button mt-2 ${branding_btn}`}
                  onClick={this.loginWithPhone.bind(this)}
                >
                  Get Code
                </button>
              )}

              {this.state.loadingCode && (
                <div className="text-sm spinner-border primary-font-color ml-2 mt-2" role="status">
                  <span className="sr-only"></span>
                </div>
              )}
            </div>
          </div>
          {this.state.whatsapp_btn_enable && this.state.settings.is_whatsapp === 1 && (
            <>
              <br></br>
              <div className='d-flex justify-content-center'>
                <button
                  className='btn btn-outline-primary'
                  href='#/'
                  onClick={() => {
                    clearInterval(this.startTimerInterval.current);
                    this.setState({ loadingCode: false, isValid: true });
                    this.enableWhatsAppVerification(!this.state.is_whatsapp_verification)
                  }}
                >
                  Try Whatsapp Verification
                </button>
              </div>
            </>
          )}
        </div>
      );
    }
  }

  render() {
    return (
      <CustomStyledLogin>
        <div id="recaptcha-container" />
        <Modal
          isOpen={this.props.showModal}
          toggle={() => this.props.toggleModal()}
          className="phone-modal login-modal-card"
        >
          <ModalHeader className='primary-font-color'>
            <h5 className='card-font-color'>
              {this.state.showCodeInput === true
                ? this.state.newUser
                  ? 'Almost Done! Last Step'
                  : 'Verify Number'
                : 'Sign Up Or Login'}
            </h5>
          </ModalHeader>
          <button className="close login-close card-color" onClick={() => {
            clearInterval(this.startTimerInterval.current);
            this.setState({ ...this.state, showCodeInput: false, loadingCode: false, isValid: true });
            this.props.toggleModal();
          }}>
            <FontAwesomeIcon icon={faTimes} color='var(--card-subtitle-color)' />
          </button>
          <ModalBody className="p-modal">{this.renderModalBody()}</ModalBody>
        </Modal>
      </CustomStyledLogin>
    );
  }
}
const CustomStyledLogin = styled.div`
  .login-close {
    background: #ffffff !important;
  }
`;

function mapStateToProps(state) {
  const { location, locationSettings } = state;
  return {
    _location: location, locationSettings
  };
}

export default connect(mapStateToProps, {})(withBackButtonHandled(CustomLogin, (props) => { }));
